import { css } from '@emotion/css'

import { colors } from '../../../../themes'

const styles = {
  button: css({
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${colors.catskillWhite}`,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: colors.athensGray,
    },
  }),
}

export default styles
